import { positions, granularity, maximumHeights, minimumHeights } from '../mixinProps'
/**
 * vc-graphics-wall base props mixins
 */
export default {
  mixins: [positions, granularity, maximumHeights, minimumHeights]
}
